module.exports = __webpack_public_path__ + "static/media/pic@2x.8480f88c.png";